import { css } from "@styled-system/css";
import { flex, grid } from "@styled-system/patterns";
export const gapTextWrapperClass = css({
	display: "inline-block",
	mx: "8",
});

export const clozeTextLearnElementWrapper = css({
	mt: "10",
	mb: "16",
});

export const clozeTextLearnElementCorrectAnswerWrapper = css({
	position: "absolute",
	p: "2",
	left: "0",
	bottom: "0",
	width: "full",
});

export const clozeTextLearnElementCorrectAnswerContainer = grid({
	gridTemplateColumns: {
		base: "12",
	},
	gap: "2",
	padding: "4",
});

export const clozeTextLearnElementIconWrapper = flex({
	gridColumn: {
		base: "[span 1 / span 1]",
	},
	alignItems: "start",
	justifyContent: "center",
});

export const clozeTextLearnElementContentWrapper = css({
	gridColumn: "[span 11 / span 11]",
	ml: "10",
});

export const clozeTextLearnElementAnswerList = css({
	listStylePosition: "outside",
	pl: "4",
});

export const clozeTextLearnElementAnswerListItem = css({});
